// confirmDiscardChanges — the ONE in-app "Discard changes?" prompt
// (perf/shell-keepalive, review D5 + Delta 2 N1, 2026-10-10).
//
//   el.call('confirmDiscardChanges', { onDiscard, onKeep })
//
// Asked before a page that DECLARES unsaved work (`hasUnsavedInput`) is
// dropped: the PageSlot keep-alive cap (canvas PageSlot `_confirmDiscardParked`)
// and the split-pane replace. Keep is the DEFAULT. Exactly one of the two
// callbacks runs, once:
//   • Discard (the confirm button)       → onDiscard
//   • Keep (the cancel button)           → onKeep
//   • Esc / a backdrop click             → onKeep. The windows plugin pops the
//     layer through ModalRoot `_popTop` / `_popAt`, which run ONLY `onClose`
//     — never `onCancel`, although the plugin's confirmDialog header says so
//     (framework ticket) — so the local `onClose` ends an open request as Keep;
//   • the layer is refused (5 layers open) → onKeep at once.
export function confirmDiscardChanges(opts = {}) {
  const el = this
  const t = (key) => el.call('polyglot', key)
  let settled = false
  const settle = (fn) => {
    if (settled) return
    settled = true
    if (typeof fn === 'function') fn()
  }
  const id = el.call('confirmDialog', {
    title: t('workspace.unsaved.discardTitle'),
    message: t('workspace.unsaved.discardMessage'),
    confirmText: t('workspace.unsaved.discard'),
    cancelText: t('workspace.unsaved.keep'),
    // The house confirm (CRUD standard D1): the primary button, no icon.
    confirmTheme: 'primary',
    icon: null,
    onConfirm: () => settle(opts.onDiscard),
    onCancel: () => settle(opts.onKeep),
    onClose: () => settle(opts.onKeep)
  })
  if (!id) settle(opts.onKeep)
  return id || null
}
